import { Component, OnInit, forwardRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import { Observable } from 'rxjs/Observable';

import { BisacService } from './../../../services/bisac.service';
import { Bisac } from '../../../models/Bisac';

@Component({
  selector: 'app-bisac-search',
  templateUrl: './bisac-search.component.html',
  styleUrls: ['./bisac-search.component.css'],
  providers: [
    BisacService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BisacSearchComponent),
      multi: true
    }
  ]
})
export class BisacSearchComponent implements OnInit {
  stateCtrl: FormControl;
  public loading = false;

  items: Observable<any>;
  selected: Bisac;
  descrizione: string;

  constructor(private service: BisacService) {
    this.stateCtrl = new FormControl();
  }

  onOptionSelected(e) {
    console.log(e.option.value)
    this.selected = e.option.value;
    this.propagateChange( e.option.value);
  }

  onChange(e) {
    console.log('change', e)
  }

  ngOnInit() {
    this.stateCtrl.valueChanges
      .debounceTime(200)
      .subscribe(val => {
        let boo = (typeof (val) === 'string' || val instanceof String);
        if (boo) {
          this.loading = true;
          this.items = this.service.search(val)
            .map(result => {
              console.log(result)
              this.loading = false;
              this.selected = undefined;
              this.propagateChange(undefined);
              if (result.success) {
                return result.items;
              }
            })
        }
      })
  }

  displayFn(item) {
    return item ? item.descrizione : item;
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: Bisac) {
    console.log('======= ************ Bisac writeValue', obj)
    this.descrizione = obj ? obj.descrizione : undefined;
    this.selected = obj;
    // this.propagateChange(this.selected);
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/bisac/bisac-search/bisac-search.component.ts